import * as React from "react";
import {Col, Row} from "react-bootstrap";
import {DropdownField} from "./FormFields";
import {PolicyNameEnum} from "../../../PolicyNameEnum";
import {AllPermissions, PolicyContext} from "../../../Policy/Provider";
import {mapCustomersForUser} from "../../utils";
import {connect as reduxConnect} from "react-redux";
import {connect as formikConnect} from "formik";
import {UserWithCustomer} from "../../Models/UserWithCustomer";
import {InnerFrame, SubHeaderWrapper} from "./styles";
import {NoFlexContent} from "@Safemate/RoleEditor/WrapperStyles";
import {LabelEnum} from "../../LabelEnum";
import {Option} from "../../../DefaultSettings/Settings/FieldWrapper";
import {Role} from "../../Models/Role";
import { SiteTypeEnum } from "../../../SiteTypeEnum";
import TreeDropdown from "@Elements/Dropdown/Tree";
import { TreeDropdownOption } from "@Elements/Dropdown/types";
import { AppState } from "@Safemate/Store/types";
import { useIntl } from "react-intl";
import { CustomerWithChildren, ICustomer, ICustomerWithPolicy } from "@Safemate/Model/Customer";

interface PermanentRoleProps{
  customerHierarchy: CustomerWithChildren| null;
  isNew: boolean;
  admin: Role;
  roles: Array<Option>;
  formKey: string;
  siteType: SiteTypeEnum;
  customersWithPolicy: ICustomerWithPolicy[];
  superfirm: ICustomer;
  strictRole: boolean;
}

const mapStateToProps = ({appData: { customersWithPolicy, customerHierarchy, currentContext, superfirm, sso:{strictRole}}, users: {role: {admin}, action: {edit: {isNew, formKey}}}}: AppState) => {
  return{
    customerHierarchy,
    isNew,
    admin,
    formKey,
    siteType: currentContext,
    superfirm,
    customersWithPolicy,
    strictRole,
  }
}

const PermanentRole =
reduxConnect(mapStateToProps)(
    formikConnect<PermanentRoleProps, UserWithCustomer>(
      ({customerHierarchy, customersWithPolicy, superfirm, formKey, roles, admin, siteType, strictRole, formik: {values: { role, subOrgs, user: { userId } }, setFieldValue}, isNew}) => {

        const {formatMessage} = useIntl();

        const [mappedCustomers, setMappedCustomers] = React.useState([] as Array<TreeDropdownOption>);
        const permissions = React.useContext(PolicyContext) as Map<PolicyNameEnum, AllPermissions>
        const isAhp = siteType === SiteTypeEnum.AHP;

        React.useEffect(() => {
          if (customerHierarchy) {
            setMappedCustomers(mapCustomersForUser(subOrgs.map(s => s.custId), customerHierarchy, permissions.get(PolicyNameEnum.USER_PRIVS).customerPermissions, isNew ? ["all", "add"] : ["all"]));
          }
        }, [customerHierarchy, userId])

        if (!mappedCustomers) return null;


        return (
          <InnerFrame border>
            <h2>
              {formatMessage({id: LabelEnum.ACCESS_LEVEL, defaultMessage: "Tilgangsnivå"})}
            </h2>
            <Row>
              <Col md={6}>
                <DropdownField
                  header={{id: LabelEnum.ROLE ,defaultMessage:"Rolle"}}
                  field={["role"]}
                  data={roles}
                  disabled={strictRole && !isNew}
                  title={formatMessage({id: LabelEnum.SELECT_ROLE, defaultMessage: "Velg rolle"})}
                  onChange={({value}: Option) => {
                    // Set the suborg field to the admin firm if admin is selected
                    if(value === admin.id){
                      setFieldValue("subOrgs", [{custId: superfirm.custId, firmName: superfirm.name, defaultAhp: superfirm.defaultAhp}])
                    }

                  }}
                />
              </Col>
              {!isAhp &&
              <Col md={6}>
                <NoFlexContent>
                  <SubHeaderWrapper>
                    {formatMessage({id: LabelEnum.SUB_UNITS, defaultMessage: "subUnits"})}
                  </SubHeaderWrapper>
                  {role === admin.id || role == -1
                    ? <div style={{padding: "10px"}}>{superfirm.name}</div>
                    : <TreeDropdown
                        disableExpand={strictRole}
                        disabled={strictRole && !isNew}
                        multiSelect
                        onChange={(values) => {
                          const selectedSuborgs = customersWithPolicy.map(cust => {
                            if(values.includes(cust.customerId.toString())){
                              return {
                                custId: cust.customerId,
                                firmName: cust.customerName,
                                defaultAhp: cust.defaultAhp
                              }
                            }
                          }).filter(c => c);
                          setFieldValue("subOrgs", selectedSuborgs);
                        }}
                        options={mappedCustomers}
                        title={formatMessage({id: LabelEnum.SELECT_CUSTOMER, defaultMessage: "Velg underavdeling"})}
                        sessionKey={formKey}
                      />
                  }
                </NoFlexContent>
              </Col>}
            </Row>
          </InnerFrame>
        )
      }
    )
  )

export default PermanentRole;
